module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_bottom-a76e72f8472ee2add703671d27ccb47e.svg";